<template>
  <div>
    <Live2faPanel />
  </div>
</template>

<script>
import Live2faPanel from "@/components/Live2faPanel.vue";
export default {
  name: "Email",
  components: {Live2faPanel}
}
</script>

<style scoped>

</style>